module.exports = __webpack_public_path__ + "assets/img/tedian5.32c86de5.png";